(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SprintDetailController', SprintDetailController);

    SprintDetailController.$inject = ['$scope', '$rootScope', '$uibModal', 'Alerta', 'previousState', 'entity', 'Sprint', 'Chamado', '$state', 'SolicitacaoDesenvolvimento', 'Ata', 'Sistema', '$sce'];

    function SprintDetailController($scope, $rootScope, $uibModal, Alerta, previousState, entity, Sprint, Chamado, $state, SolicitacaoDesenvolvimento, Ata, Sistema, $sce) {
        var vm = this;

        vm.sprint = entity;
        vm.previousState = previousState.name;
        vm.horasPlanejadas = 0;
        vm.horasPlanejadasSprintAberta = 0;
        vm.tempos = {};
        vm.tempoTotalGasto = 0;
        vm.modulosSprintAndamento = [];
        vm.modulosSprintAberta = [];
        vm.encerrarSprint = encerrarSprint;
        vm.criarPlanejamento = criarPlanejamento;
        vm.criarEncerramento = criarEncerramento;
        vm.criarReuniaoDiaria = criarReuniaoDiaria;

        var unsubscribe = $rootScope.$on('chamadosApp:sprintUpdate', function (event, result) {
            vm.sprint = result;
        });
        $scope.$on('$destroy', unsubscribe);


        function buildBashboardUrl() {
            var dashBoardUrl = "https://dashboard.webpublico.app.br/public/dashboard/6284eb5c-8fe2-419c-bb48-f2fc985570e9?sprint="+vm.sprint.id;
            vm.dashBoardUrl = $sce.trustAsResourceUrl(dashBoardUrl);
        }

        function findModuloIndex(modulos, moduloId) {
            var index = -1;
            angular.forEach(modulos, function (modulo, ind) {
                if (modulo.modulo.id === moduloId) {
                    index = ind;
                }
            });
            return index;
        }

        function ensureModulo(modulos, modulo, comExtrasAberta) {
            var index = findModuloIndex(modulos, modulo.id);
            if (index < 0) {
                var novoModulo = {
                    modulo: modulo,
                    chamadosAFazer: 0,
                    chamadosFazendo: 0,
                    chamadosEntregues: 0
                };
                if (comExtrasAberta) {
                    novoModulo.tempoEstimado = 0;
                    novoModulo.chamadosSemTarefas = [];
                }
                modulos.push(novoModulo);
                index = modulos.indexOf(novoModulo);
            }
            return index;
        }

        function processarChamadosAndamento(chamados) {
            vm.sprint.chamados = chamados;
            vm.sprint.horasDisponiveis = 0;

            angular.forEach(vm.sprint.clientes, function (cliente) {
                vm.sprint.horasDisponiveis = vm.sprint.horasDisponiveis + cliente.horasDisponiveis;
            });

            angular.forEach(chamados, function (chamado) {
                var index = ensureModulo(vm.modulosSprintAndamento, chamado.modulo, false);

                if (chamado.situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosFazendo = vm.modulosSprintAndamento[index].chamadosFazendo + 1;
                }

                if (chamado.situacao !== 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosEntregues = vm.modulosSprintAndamento[index].chamadosEntregues + 1;
                }

                Chamado.getSolicitacoes({id: chamado.id}, function (solicitacoes) {
                    chamado.solicitacoes = solicitacoes;

                    angular.forEach(solicitacoes, function (sol) {
                        if (sol.situacao === 'A_FAZER' && chamado.situacao === 'EM_DESENVOLVIMENTO') {
                            vm.modulosSprintAndamento[index].chamadosAFazer = vm.modulosSprintAndamento[index].chamadosAFazer + 1;
                        }

                        SolicitacaoDesenvolvimento.getTempoGastoByTicket({id: sol.id}, function (data) {
                            adicionarTempo(data);
                        });
                    });
                });

                vm.horasPlanejadas = vm.horasPlanejadas + (chamado.tempoEstimado || 0);
            });
        }

        function processarTarefasAndamento(tarefas) {
            vm.sprint.tarefas = tarefas;
            vm.sprint.horasDisponiveis = 0;

            angular.forEach(vm.sprint.clientes, function (cliente) {
                vm.sprint.horasDisponiveis = vm.sprint.horasDisponiveis + cliente.horasDisponiveis;
            });

            angular.forEach(tarefas, function (tarefa) {
                var chamado = tarefa.chamado || {};
                var modulo = tarefa.modulo || chamado.modulo;
                if (!modulo) {
                    return;
                }
                var index = ensureModulo(vm.modulosSprintAndamento, modulo, false);
                var situacao = chamado.situacao;

                if (situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosFazendo = vm.modulosSprintAndamento[index].chamadosFazendo + 1;
                } else if (situacao) {
                    vm.modulosSprintAndamento[index].chamadosEntregues = vm.modulosSprintAndamento[index].chamadosEntregues + 1;
                }

                if (tarefa.situacao === 'A_FAZER' && situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosAFazer = vm.modulosSprintAndamento[index].chamadosAFazer + 1;
                }

                SolicitacaoDesenvolvimento.getTempoGastoByTicket({id: tarefa.id}, function (data) {
                    adicionarTempo(data);
                });

                vm.horasPlanejadas = vm.horasPlanejadas + (Number(tarefa.tempoEstimado) || 0);
            });
        }

        function processarTarefasAberta(aberta, tarefas) {
            aberta.tarefas = tarefas;
            vm.sprintAberta = aberta;
            vm.sprintAberta.horasDisponiveis = 0;

            angular.forEach(vm.sprintAberta.clientes, function (cliente) {
                vm.sprintAberta.horasDisponiveis = vm.sprintAberta.horasDisponiveis + cliente.horasDisponiveis;
            });

            angular.forEach(tarefas, function (tarefa) {
                var chamado = tarefa.chamado || {};
                var modulo = tarefa.modulo || chamado.modulo;
                if (!modulo) {
                    return;
                }
                var index = ensureModulo(vm.modulosSprintAberta, modulo, true);
                var situacao = chamado.situacao;

                vm.modulosSprintAberta[index].tempoEstimado =
                    vm.modulosSprintAberta[index].tempoEstimado + (Number(tarefa.tempoEstimado) || 0);

                if (situacao === 'AGUARDANDO_DESENVOLVIMENTO' || situacao === 'EM_ANALISE' || situacao === 'EM_ANALISE_DESENVOLVIMENTO') {
                    vm.modulosSprintAberta[index].chamadosAFazer = vm.modulosSprintAberta[index].chamadosAFazer + 1;
                } else if (situacao) {
                    vm.modulosSprintAberta[index].chamadosEntregues = vm.modulosSprintAberta[index].chamadosEntregues + 1;
                }
                if (situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAberta[index].chamadosFazendo = vm.modulosSprintAberta[index].chamadosFazendo + 1;
                }

                vm.horasPlanejadasSprintAberta = vm.horasPlanejadasSprintAberta + (Number(tarefa.tempoEstimado) || 0);
            });
        }

        function loadChamados() {

            vm.chamado = {sprint: vm.sprint};
            Chamado.queryByFiltro(vm.chamado, function (data) {
                vm.chamados = data;
            });


            Sistema.getByUser({}, function (data) {
                vm.sistemas = data;

                angular.forEach(vm.sistemas, function (sistema) {
                    // FECHADA: histórico ainda em chamado.sprint; ABERTA/EM_ANDAMENTO: sprint na tarefa
                    if (vm.sprint.situacao === 'FECHADA') {
                        Chamado.queryBySprint({sprintId: vm.sprint.id, sistemaId: sistema.id}, function (chamados) {
                            processarChamadosAndamento(chamados);
                        });
                    } else {
                        SolicitacaoDesenvolvimento.queryBySprintSistema({
                            sprintId: vm.sprint.id,
                            sistemaId: sistema.id
                        }, function (tarefas) {
                            processarTarefasAndamento(tarefas);
                        });
                    }
                });

                angular.forEach(vm.sistemas, function (sistema) {
                    Sprint.getBySituacao({situacao: 'ABERTA'}, function (aberta) {
                        SolicitacaoDesenvolvimento.queryBySprintSistema({
                            sprintId: aberta.id,
                            sistemaId: sistema.id
                        }, function (tarefas) {
                            processarTarefasAberta(aberta, tarefas);
                        });
                    });
                });

            });

        }

        loadChamados();
        buildBashboardUrl();

        function confirmEncerrar() {
            Sprint.encerrar(vm.sprint, function (data) {
                Alerta.success("Operação realizada", "A Sprint foi encerrada!")
                $state.go('sprint')
            }, function error(error) {
                Alerta.error("Operação Não realizada", "Tente novamente!")
            });
        }

        function cancel() {
            //Alerta.success("Operação NÃO Realizada", "")
        }


        function encerrarSprint() {
            Alerta.confirm("Atenção!",
                "Você tem certeza que deseja encerrar a Srpint " + vm.sprint.descricao + "?",
                "warning",
                confirmEncerrar, cancel);
        }

        function criarPlanejamento(sprint) {
            Ata.criarPlanejamento(sprint, function (data) {
                $state.reload(true);
            });
        }

        function criarEncerramento(sprint) {
            Ata.criarEncerramento(sprint, function (data) {
                $state.reload(true);
            });
        }

        function criarReuniaoDiaria(sprint) {
            Ata.criarReuniaoDiaria(sprint, function (data) {
                $state.reload(true);
            });
        }

        function adicionarTempo(data) {
            angular.forEach(data, function (tempo) {
                vm.tempoTotalGasto = vm.tempoTotalGasto + tempo.tempo;
                if (!vm.tempos[tempo.tipo]) {
                    vm.tempos[tempo.tipo] = {
                        tipo: tempo.tipo,
                        tempo: tempo.tempo
                    };
                } else {
                    vm.tempos[tempo.tipo].tempo = vm.tempos[tempo.tipo].tempo + tempo.tempo;
                }
            });
        }
    }
})();
